
import Model from '@app/Model'
import { CategorySet as Category } from '@/models/CategorySet'
import { PartCategory } from '@/models/PartCategory'

export class CategorySet extends Model {
	static fields () {
		return {
			id: null,
			partCategory: PartCategory,
			nearestParentId: null
		}
	}

	static hasMany () {
		return {
			children: Category
		}
	}
}
export function createPartCategorySet (data) {
	return Object.freeze(new CategorySet(data))
}
